import { IconButton } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import ModalTemplate from "../../components/templates/ModalTemplate";
import Button from "../../components/atoms/Button";
import { PaymentType } from "../../app/types/ProposalTypes";

function ConfirmationModal({
  handleClose,
  setShowConfirmationModal,
  showConfirmationModal,
  data,
  fontClass,
  stylingType = "events_styling",
}: {
  handleClose: () => void;
  setShowConfirmationModal: React.Dispatch<React.SetStateAction<boolean>>;
  showConfirmationModal: boolean;
  data: PaymentType[] | null;
  fontClass?: string;
  stylingType?: "events_styling" | "booking_proposal_styling";
}) {
  const handleConfirmationClose = () => {
    setShowConfirmationModal(false);
    handleClose();
  };

  const handleProceed = () => {
    setShowConfirmationModal(false);
  };
  return (
    <ModalTemplate
      open={showConfirmationModal}
      handleClose={handleConfirmationClose}
      className={`w-full max-w-md bg-white ${fontClass || "font-roboto"}`}
    >
      {/* Header */}
      <div className="p-4 flex flex-row justify-between items-center bg-white sticky top-0 z-10">
        <span className="font-semibold text-xl">
          {globalThis.translate.em.proposal.payment_modal.confirmation_header}
        </span>
        <IconButton onClick={handleConfirmationClose} className="h-8 w-8">
          <CloseIcon />
        </IconButton>
      </div>

      {/* Content */}
      <div className="p-6 bg-white">
        <p className="text-lg text-[#2D2020] mb-6">
          {!data || data.length === 0
            ? globalThis.translate.em.proposal.payment_modal.sign_only
            : data && data[0].payment_type === "payment"
              ? globalThis.translate.em.proposal.payment_modal.text
              : globalThis.translate.em.proposal.payment_modal
                  .card_as_guarantee_text}
        </p>
      </div>

      {/* Footer */}
      <div className="flex gap-1 bg-[#FAFAFA]">
        <div className="flex flex-row justify-end items-center w-full gap-3 px-6 py-4">
          <button
            onClick={handleConfirmationClose}
            className="py-2 px-6 font-medium text-gray-700 hover:bg-gray-50"
          >
            {globalThis.translate.em.proposal.payment_modal.cancel_confirmation}
          </button>
          <Button
            onClick={handleProceed}
            className="bg-[#BF5934] py-2 px-6 rounded text-white font-medium hover:bg-[#A04426]"
            stylingType={stylingType}
          >
            {globalThis.translate.em.proposal.payment_modal.proceed}
          </Button>
        </div>
      </div>
    </ModalTemplate>
  );
}

export default ConfirmationModal;
